import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export const RequireAuth = ({ area, children }) => {
  const { me, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <Loader2 className="animate-spin text-slate-500" />
      </div>
    );
  }
  if (!me || me.etapa !== "completa") {
    if (area === "panel") sessionStorage.setItem("volver_a", window.location.pathname);
    return <Navigate to="/ingresar" replace />;
  }
  const isSA = me.usuario.rol === "superadmin";
  if (area === "admin" && !isSA) return <Navigate to="/panel" replace />;
  if (area === "panel" && isSA && !me.soporte) return <Navigate to="/admin" replace />;
  return children;
};
